import React from 'react'
import Testing from '../Components/Testing/Testing';
import Testing1 from '../Components/Testing1/Testing1';
import Testingcurriculum from '../Components/Testingcurriculum/Testingcurriculum';
import Watermark from '../Components/Watermark/Watermark';
const Testingpage = () => {
  return (
    <div>
      <Watermark/>
      <Testing/>
      <Testing1/>
      <Testingcurriculum/>
    </div>
  )
}

export default Testingpage;
